import _ from 'lodash';

export const useCheckDisableInitialWorkflowSpec = ({
  productList = [],
  productId,
}) => {
  const disableInitialWorkflowProductFull = () => {
    return false;
  };

  const disableInitialWorkflowProductGrid = () => {
    if (!Array.isArray(productList)) return true;

    if (productList?.length <= 0) return true;

    const existAssignedSupplier = _.some(
      productList,
      (product) => product?.assignTo
    );

    return existAssignedSupplier;
  };

  const isDisableInitialQaSpecWorkflow = productId
    ? disableInitialWorkflowProductFull()
    : disableInitialWorkflowProductGrid();

  return isDisableInitialQaSpecWorkflow;
};
